import map from "lodash/map";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import { Suspense, useEffect } from "react";

import routes from "./routes";
import Layout from "./components/Layout";
import themedLazy from "./utils/themedLazy";

import "./App.css";
import { useSelector } from "react-redux";
import { trackPageView } from "./utils/pixel";

// Khung dashboard (antd Drawer/Dropdown/Tooltip…) chỉ tải cho admin/nhân viên → không nằm trong JS chính của khách
const Dashboard = themedLazy(() => import("./components/Dashboard"));

const PixelPageView = () => {
  const location = useLocation();
  useEffect(() => { trackPageView(); }, [location.pathname]);
  return null;
};

const Spinner = () => (
  <span className="h-8 w-8 animate-spin rounded-full border-[3px] border-brand-100 border-t-brand-600" role="status" aria-label="Đang tải" />
);

// Chờ file JS của trang: header/footer đã hiện (Suspense nằm TRONG Layout); min-h giữ footer dưới màn hình
const PageFallback = () => (
  <div className="flex min-h-screen items-start justify-center pt-24">
    <Spinner />
  </div>
);

const FullFallback = () => (
  <div className="flex min-h-screen items-center justify-center">
    <Spinner />
  </div>
);

const Forbidden = () => (
  <div className="container-hm py-16 text-center">
    <p className="m-0 text-6xl font-bold text-slate-200">403</p>
    <h1 className="m-0 mt-3 text-2xl font-bold text-slate-900">Không có quyền truy cập</h1>
    <p className="m-0 mt-2 text-base text-slate-500">Xin lỗi bạn không có quyền truy cập trang này!</p>
    <Link to="/" className="mt-6 inline-flex h-11 items-center rounded-xl bg-brand-600 px-6 text-base font-semibold text-white no-underline hover:bg-brand-700">
      Về trang chủ
    </Link>
  </div>
);

function App() {
  const { currentUser } = useSelector((state) => state?.authReducer?.login);
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <PixelPageView />
      <Suspense fallback={<FullFallback />}>
      <Routes>
        {map(routes, (route) => {
          const Element = route.element;
          return (
            <Route
              path={route.path}
              key={route.path}
              element={
                route?.isDashboard ? (
                  currentUser?.role === "admin" || currentUser?.role === "employee" ? (
                    <Dashboard>
                      <Suspense fallback={<PageFallback />}>
                        <Element />
                      </Suspense>
                    </Dashboard>
                  ) : (
                    <Layout>
                      <Forbidden />
                    </Layout>
                  )
                ) : (
                  <Layout>
                    <Suspense fallback={<PageFallback />}>
                      <Element />
                    </Suspense>
                  </Layout>
                )
              }
            />
          );
        })}
      </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
